import ValidateModule from "./ValidateModule";

import type { IEventChannel, ApiOpts } from "../model/Models";
import type AjaxRequestBroker from "../AjaxRequestBroker";

const es = global.es;

/**
 * @class NotificationModule
 */
export default class NotificationModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;

        // TODO FIXME Does this even make sense nowadays?
        eventChannel.addListener("onDestroy", () => {
            // prevent memory leaks when the map widget is destroyed
            this.eventChannel = this.rqBroker = this.resourceName = null;
        });

        this.countUnseen = this.countUnseen.bind(this);
        this.getUserNotifications = this.getUserNotifications.bind(this);
        this.getOlderUserNotifications = this.getOlderUserNotifications.bind(this);
        this.markRead = this.markRead.bind(this);
        this.markAllRead = this.markAllRead.bind(this);
    }

    /**
     * Returns the number of unseen notifications
     * 
     * @param opts
     * 
     * @return number of unseen notifications
     */
    countUnseen(opts?: ApiOpts) {
        const url = es.api.getURL(this.resourceName) + '/unseen';

        return this.rqBroker.doGet({
            'url': url,
            'opts': opts
        });
    }
    
    /**
     * getUserNotifications()
     * As a side-effect, unseen is set to 0
     * 
     * @param nLimit
     * @param opts
     * 
     * @return jQuery deferred object
     */
    getUserNotifications(nLimit: number, opts?: ApiOpts) {
        if (!ValidateModule.checkInt(nLimit, true, true)) {
            return es.util.deferred.rejected();
        }

        const url = es.api.getURL(this.resourceName) + '/user?nLimit=' + nLimit;
        
        return this.rqBroker.doGet({
            'url': url,
            'opts': opts
        });
    }
    
    /**
     * getOlderUserNotifications()
     * As a side-effect, unseen is set to 0?
     * 
     * @param beforeUserNotificationId
     * @param nLimit
     * @param opts
     * 
     * @return jQuery deferred object
     */
    getOlderUserNotifications(beforeUserNotificationId: number, nLimit: number, opts?: ApiOpts) {
        if (!ValidateModule.checkId(beforeUserNotificationId) ||
            !ValidateModule.checkInt(nLimit, true, true)) {
            return es.util.deferred.rejected();
        }
        
        const url = es.api.getURL(this.resourceName) + '/user?beforeUserNotificationId=' + beforeUserNotificationId + '&nLimit=' + nLimit;

        return this.rqBroker.doGet({
            'url': url,
            'opts': opts
        });
    }
    
    /**
     * Marks a user notification as read
     * 
     * @param userNotificationId
     * @param opts
     * 
     * @return jQuery deferred object
     */
    markRead(userNotificationId: number, opts?: ApiOpts) {
        if (!ValidateModule.checkId(userNotificationId)) {
            return es.util.deferred.rejected();
        }

        const url = es.api.getURL(this.resourceName) + '/user/markRead/' + userNotificationId;
        
        return this.rqBroker.doPut({
            'url': url,
            'opts': opts
        });
    }
    
    /**
     * Marks all user notifications as read
     * 
     * @param opts
     * 
     * @return jQuery deferred object
     */
    markAllRead(opts?: ApiOpts) {
        const url = es.api.getURL(this.resourceName) + '/user/markAllRead';

        return this.rqBroker.doPut({
            'url': url,
            'opts': opts
        });
    }
}
